export const STATUS_COLORS = {
  accepted: 'green',
  active: 'blue',
  approved: 'green',
  'awaiting documents': 'orange',
  canceled: 'red',
  cancelled: 'red',
  complete: 'green',
  completed: 'green',
  denied: 'red',
  draft: 'grey',
  drafted: 'grey',
  expired: 'red',
  failed: 'red',
  'in progress': 'blue',
  locked: 'grey',
  open: 'blue',
  partial: 'orange',
  pending: 'grey',
  processed: 'green',
  reviewed: 'blue',
  sent: 'blue',
  signed: 'green',
  skipped: 'orange',
  submitted: 'grey',
  void: 'grey',
  withdrawn: 'grey',
};

function normalizeStatusKey(status) {
  if (status == null || status === '') return '';

  return String(status).toLowerCase();
}

export function statusColorNameForKey(statusKey) {
  const key = normalizeStatusKey(statusKey);

  return STATUS_COLORS[key] ?? 'grey';
}

export default function useStatusChipColors() {
  return {
    STATUS_COLORS,
    statusColorNameForKey,
  };
}
